<template>
	<b-container class="pg-instruction-cont">
		<img
			class="pg-img-pos"
			src="../../assets/newdesign/dashboard/games/2048-haze.svg"
			alt=""
		/>
		<span class="pg-blue-txt d-flex w80">2048 Game Instructions</span>
		<h2 class="mt-3 mb-2">Objective :</h2>
		<h3>Combine numbered tiles to reach the tile 2048.</h3>
		<h2 class="mt-3 mb-2">How to Play :</h2>
		<main class="d-flex pl-1">
			<h4 class="mr-1">1.</h4>
			<section>
				<h4>Use Arrow Keys :</h4>
				<h3>
					Swipe or press Up, Down, Left, or Right to move all tiles in the
					chosen direction.
				</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">2.</h4>
			<section>
				<h4>Combine Tiles :</h4>
				<h3>
					When two tiles with the same number touch, they merge into one (e.g.,
					2 + 2 = 4, 4 + 4 = 8).
				</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">3.</h4>
			<section>
				<h4>New Tile :</h4>
				<h3>A new tile (either 2 or 4) appears after each move.</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">4.</h4>
			<section>
				<h4>Game Over :</h4>
				<h3>
					The game ends when the board is full and no more moves are possible.
				</h3>
			</section>
		</main>
	</b-container>
</template>

<script>
export default {};
</script>

<style></style>
